const m = window.require("@ember/debug/container-debug-adapter");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;